import {Routes, Route} from "react-router-dom";
import styled from "styled-components";
import Footer from "../components/Footer";
import HeaderAppBar from "../components/HeaderAppBar";
import SideBar from "../components/SideBar";
import FactoryList from "../containers/factory/FactoryList";
import MyProject from "../containers/project/MyProject";
import ProjectList from "../containers/project/ProjectList";
import EditMyProject from "../containers/project/EditMyProject";
import ManageProject from "../containers/project/ManageProject";

const LayoutContainer = styled.main`
  position: relative;
  width: 100%;
  min-width: 1600px;
  height: 100vh;
  background-color: ${({theme}) => theme.palette.background.default};
`;

const DashboardMain = styled.div`
  width: 100%;
`;

const DummyContainer = styled.div`
  width: 100%;
  height: 80px;
`;

const MainPage = () => {
  return (
    <LayoutContainer>
      <SideBar />
      <DashboardMain>
        <HeaderAppBar />
        <DummyContainer />
        <Routes>
          <Route path="" element={<ProjectList />} />
          <Route path="manageProject" element={<ManageProject />} />
          <Route path="factoryList" element={<FactoryList />} />
          <Route path="myProject/:_id" element={<MyProject />} />
          <Route path="editProject" element={<EditMyProject />} />
        </Routes>
        {/* <Footer /> */}
      </DashboardMain>
    </LayoutContainer>
  );
};

export default MainPage;
